(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mk-video-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVideoBanner(el) {
    if (el.dataset.mkInit === '1') return;
    el.dataset.mkInit = '1';

    var video = el.querySelector('.mk-video-banner__video');
    if (!video) return;

    var autoplay = el.dataset.autoplay === 'true';
    var loop = el.dataset.loop === 'true';
    var controls = el.dataset.controls === 'true';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var loaded = false;

    function pickSrc() {
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      var mobileSrc = el.dataset.videoMobile;
      var desktopSrc = el.dataset.videoDesktop;
      // Only the matching device URL is ever assigned, so only it downloads.
      return (isMobile && mobileSrc) ? mobileSrc : (desktopSrc || mobileSrc);
    }

    function loadVideo() {
      if (loaded) return;
      var src = pickSrc();
      if (!src) return;
      loaded = true;
      video.muted = true; // required before any autoplay request
      if (loop) video.loop = true;
      video.setAttribute('playsinline', '');
      video.src = src;
      video.load();
    }

    function tryPlay() {
      if (!loaded) return;
      if (reduceMotion || !autoplay) return; // keep poster, do not autoplay
      video.muted = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          // Autoplay blocked or playback failed: keep the poster visible.
          el.classList.remove('is-playing');
        });
      }
    }

    video.addEventListener('playing', function () {
      el.classList.add('is-playing'); // fade video in, poster out — only once truly playing
    });
    video.addEventListener('canplay', tryPlay);
    video.addEventListener('error', function () {
      el.classList.remove('is-playing'); // fall back to poster on failure
    });

    // Lazy-load shortly before the section scrolls into view.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadVideo();
          tryPlay();
        } else if (loaded && !video.paused) {
          video.pause(); // pause when off-screen
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 });

    io.observe(el);

    // Pause when the tab is hidden; resume when visible (if on-screen).
    document.addEventListener('visibilitychange', function () {
      if (!loaded) return;
      if (document.hidden) {
        video.pause();
      } else {
        var r = el.getBoundingClientRect();
        var onScreen = r.bottom > 0 && r.top < window.innerHeight;
        if (onScreen) tryPlay();
      }
    });

    // controls flag is already reflected as an HTML attribute by Liquid;
    // expose it here too in case of future scripting needs.
    if (controls) video.setAttribute('controls', '');
  }

  function initAll() {
    document.querySelectorAll('[data-mk-video-banner]').forEach(initVideoBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init for sections added/edited in the Theme Editor.
  document.addEventListener('shopify:section:load', function (e) {
    var node = e.target.querySelector ? e.target.querySelector('[data-mk-video-banner]') : null;
    if (node) initVideoBanner(node);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
